import React from 'react'
//https://github.com/zpao/qrcode.react

import { DEFAULT_PROPS, DEFAULT_IMG_PROPS } from './constants'
import QRCodeCanvas from './QRCodeCanvas'
import QRCodeSVG from './QRCodeSVG'

/** @ProductComponent */
export const QRCode = (props) => {
  const {
    /**
     * an element/component that will be rendered as PNG, svg or canvas.  */
    renderAs = 'canvas',
    /**
     * @default '#ffffff'
     * background color of the QR code
     * */
    bgColor = DEFAULT_PROPS.bgColor,
    /**
     * @default '#000000'
     * foreground color of the QR code
     * */
    fgColor = DEFAULT_PROPS.fgColor,
    /** id of the QR code element */
    id,
    /** Boolean prop that determinates are margin included or not */
    includeMargin = DEFAULT_PROPS.includeMargin,
    /**
     * @default 128
     * Size of the QR code in pixels
     * */
    size = DEFAULT_PROPS.size,
    /**
     * Error correction level of the QR code
     * */
    value,
    /** Image to be included in the QR code */
    img,
    /**
     * @default false
     * If true, the background of the logo will be removed
     * */
    removeLogoBackground = DEFAULT_PROPS.removeLogoBackground,
    /** Size of the image to be included in the QR code */
    imgSize = {
      width: DEFAULT_IMG_PROPS.width,
      height: DEFAULT_IMG_PROPS.height,
    },
  } = props
  const Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas
  const hasLogo = img !== null

  return (
    <Component
      id={id}
      img={img}
      size={size}
      level={hasLogo ? 'H' : 'L'}
      value={value}
      bgColor={bgColor}
      fgColor={fgColor}
      includeMargin={includeMargin}
      removeLogoBackground={removeLogoBackground}
      imgSize={imgSize}
    />
  )
}
